<template>
    <div class="h-full w-full">
        <SideNav :class="{ 'mobile-active': isMobile }" />

        <div class="nav-responsive flex-grow" :class="{ 'mobile-active': isMobile }">
            <router-view id="viewBase" v-slot="{ Component, route }">
                <transition name="router-slide" mode="out-in">
                    <div :key="route.fullPath" class="route-view-shell">
                        <component :is="Component" class="w-full h-full" />
                    </div>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
    import SideNav from '@/components/SideNav.vue';
    import { ref } from 'vue';
    export default {
        name: 'ViewBase',
        components: { SideNav },
        setup() {
            const isMobile = ref(false);

            return { isMobile };
        },
    };
</script>

<style lang="scss">
    .nav-responsive {
        padding: 0 1.25rem 0 calc(clamp(260px, 20vw, 300px) + 20px);
        height: 100%;
        overflow-y: auto;
        &.mobile-active {
            padding: 0 1rem;
        }
    }

    .route-view-shell {
        min-height: 100%;
        width: 100%;
    }

    @media (min-width: 1536px) {
        .nav-responsive {
            padding-left: calc(clamp(260px, 15vw, 300px) + 20px);
        }
    }
</style>
